'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index$1 = require('../../node_modules/classnames/index.js');

var index = require('../../node_modules/prop-types/index.js');

var Hero = require('../../primitives/Hero/Hero.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var FeaturedMarquee = function FeaturedMarquee(props) {
  var author = props.author,
      date = props.date,
      title = props.title,
      className = props.className,
      tall = props.tall,
      backgroundImage = props.backgroundImage,
      cerosiFrame = props.cerosiFrame,
      logo = props.logo,
      cleanMarquee = props.cleanMarquee;
  var classes = index$1['default']('featured-marquee', tall && 'tall-marquee', className);

  var renderText = function renderText() {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "container"
    }, /*#__PURE__*/React__default['default'].createElement("h1", {
      className: "title"
    }, title), /*#__PURE__*/React__default['default'].createElement("p", {
      className: "details"
    }, author && /*#__PURE__*/React__default['default'].createElement("span", {
      className: "author"
    }, "By ", author), /*#__PURE__*/React__default['default'].createElement("span", {
      className: "date-published"
    }, date)), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "logo-container"
    }, /*#__PURE__*/React__default['default'].createElement("object", {
      data: logo,
      type: "image/svg+xml",
      "aria-label": "featured-issue-discovery-logo",
      className: "logo"
    })));
  };

  if (cerosiFrame) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "featured-marquee iframe-container"
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      dangerouslySetInnerHTML: {
        __html: cerosiFrame
      }
    }));
  } else {
    return /*#__PURE__*/React__default['default'].createElement(Hero.Hero, {
      img: backgroundImage,
      className: classes
    }, !cleanMarquee && renderText());
  }
};

FeaturedMarquee.defaultProps = {
  cerosiFrame: null
};
FeaturedMarquee.propTypes = {
  author: index['default'].string,
  backgroundImage: index['default'].string,
  cerosiFrame: index['default'].node,
  className: index['default'].string,
  cleanMarquee: index['default'].bool,
  date: index['default'].string,
  logo: index['default'].string,
  tall: index['default'].bool,
  title: index['default'].string
};
exports.FeaturedMarquee = FeaturedMarquee;
exports['default'] = FeaturedMarquee;